import React from "react";

interface IScanEyeIconProps {
    sizeX?: number;
    sizeY?: number;
}

export const ScanEyeIcon: React.FC<IScanEyeIconProps> = ({ sizeX = 24, sizeY = 24 }) => {
    return (
        <svg width={sizeX} height={sizeY} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M3 7V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H7M17 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V7M21 17V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H17M7 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V17M13 12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12ZM18.944 12.33C19.0187 12.1163 19.0187 11.8837 18.944 11.67C18.381 10.2904 17.4198 9.10982 16.1831 8.27876C14.9463 7.44771 13.49 7.00388 12 7.00388C10.51 7.00388 9.0537 7.44771 7.81694 8.27876C6.58019 9.10982 5.61901 10.2904 5.056 11.67C4.98131 11.8837 4.98131 12.1163 5.056 12.33C5.61901 13.7096 6.58019 14.8902 7.81694 15.7212C9.0537 16.5523 10.51 16.9961 12 16.9961C13.49 16.9961 14.9463 16.5523 16.1831 15.7212C17.4198 14.8902 18.381 13.7096 18.944 12.33Z"
                stroke="#D0BDF8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
}
